module.exports = __webpack_public_path__ + "img/Company_MV.a743c903.png";